import { createAction, props } from '@ngrx/store';

import {
  Quote,
  QuoteAdjustment,
  QuoteStatusUpdate,
} from '@lockton-apps/shared/interfaces';

export enum EnquiryOverviewActionTypes {
  init = '[EnquiryOverview Page] Init',
  AdjustmentApplied = '[Enquiry Overview Page] Adjustment Applied',
  QuoteStatusUpdated = '[Enquiry Overview Page] Quote Status Updated',
  ChecklistChanged = '[Enquiry Overview Page] Checklist Changed',
  PolicyMarkedAsBound = '[Enquiry Overview Page] Policy Marked As Bound',
  PolicyNotTakenUp = '[Enquiry Overview Page] Policy Not Taken Up',
  AssignContact = '[Enquiry Overview Page] Assigning Contact',
  SendRenewalInvite = '[Enquiry Overview Page] Send Renewal Invite',
  ProposalReturned = '[Enquiry Overview Page] Proposal Returned',
  ProposalSubmitted = '[Enquiry Overview Page] Proposal Submitted',
  QuoteRequested = '[Enquiry Overview Page] Quote Requested',
  QuoteReady = '[Enquiry Overview Page] Quote Ready',
  HoldQuote = '[Enquiry Overview Page] Hold Quote',
  SendToClient = '[Enquiry Overview Page] Send To Client',
  AcceptQuote = '[Enquiry Overview Page] Accept Quote',
  Invoice = '[Enquiry Overview Page] Invoice',
  PaymentReceived = '[Enquiry Overview Page] Payment Received',
  Complete = '[Enquiry Overview Page] Complete',
  Navigated = '[Enquiry Overview Page] Navigated',
}

export const EnquiryOverviewActions = {
  init: createAction(EnquiryOverviewActionTypes.init),
  adjustmentApplied: createAction(
    EnquiryOverviewActionTypes.AdjustmentApplied,
    props<{ quote: Quote; adjustment: QuoteAdjustment }>()
  ),
  quoteStatusUpdated: createAction(
    EnquiryOverviewActionTypes.QuoteStatusUpdated,
    props<{ update: QuoteStatusUpdate }>()
  ),
  checklistChanged: createAction(
    EnquiryOverviewActionTypes.ChecklistChanged,
    props<{ quoteId: number; checklist: Record<string, boolean> }>()
  ),
  policyMarkedAsBound: createAction(
    EnquiryOverviewActionTypes.PolicyMarkedAsBound,
    props<{ quote: Quote }>()
  ),
  notTakenUp: createAction(
    EnquiryOverviewActionTypes.PolicyNotTakenUp,
    props<{ quote: Quote }>()
  ),
  assignContact: createAction(
    EnquiryOverviewActionTypes.AssignContact,
    props<{ quote: Quote }>()
  ),
  sendRenewalInvite: createAction(
    EnquiryOverviewActionTypes.SendRenewalInvite,
    props<{ quote: Quote }>()
  ),
  proposalReturned: createAction(
    EnquiryOverviewActionTypes.ProposalReturned,
    props<{ quote: Quote }>()
  ),
  proposalSubmitted: createAction(
    EnquiryOverviewActionTypes.ProposalSubmitted,
    props<{ quote: Quote }>()
  ),
  quoteRequested: createAction(
    EnquiryOverviewActionTypes.QuoteRequested,
    props<{ quote: Quote }>()
  ),
  quoteReady: createAction(
    EnquiryOverviewActionTypes.QuoteReady,
    props<{ quote: Quote }>()
  ),
  holdQuote: createAction(
    EnquiryOverviewActionTypes.HoldQuote,
    props<{ quote: Quote }>()
  ),
  sendToClient: createAction(
    EnquiryOverviewActionTypes.SendToClient,
    props<{ quote: Quote }>()
  ),
  acceptQuote: createAction(
    EnquiryOverviewActionTypes.AcceptQuote,
    props<{ quote: Quote }>()
  ),
  invoice: createAction(
    EnquiryOverviewActionTypes.Invoice,
    props<{ quote: Quote }>()
  ),
  paymentReceived: createAction(
    EnquiryOverviewActionTypes.PaymentReceived,
    props<{ quote: Quote }>()
  ),
  complete: createAction(
    EnquiryOverviewActionTypes.Complete,
    props<{ quote: Quote }>()
  ),
  navigated: createAction(
    EnquiryOverviewActionTypes.Navigated,
    props<{ quote: Quote }>()
  ),
};
